<template>
    <a-modal
        :title="isUpdate ? '修改单页' : '新增单页'"
        :width="900"
        :visible="visible"
        :confirmLoading="loading"
        :maskClosable="false"
        @ok="handleOk"
        @cancel="handleCancel"
    >
        <a-spin :spinning="loading">
            <a-form-model ref="adminForm" :model="form" :label-col="{span:5}" :wrapper-col="{span:15}" autoComplete="off">
                <a-form-model-item label="单页名称" prop="name"
                    :rules="[
                        {required: true, message: '必填，不能为空', trigger: 'blur'}
                    ]"
                >
                    <a-input v-model="form.name" placeholder="请输入单页名称" />
                </a-form-model-item>
                <a-form-model-item label="标识" prop="ident"
                    :rules="[
                        {required: true, message: '必填，不能为空', trigger: 'blur'},
                        {pattern: /^[a-zA-Z0-9_]+$/, message: '标识只能包含字母、数字和下划线', trigger: 'blur'}
                    ]"
                >
                    <a-input v-model="form.ident" :disabled="isUpdate" placeholder="请输入标识（字母、数字、下划线）" />
                </a-form-model-item>

                <a-form-model-item label="内容" prop="content"
                    :rules="[
                        {required: true, message: '必填，不能为空', trigger: 'change'}
                    ]"
                >
                    <div class="quill-editor-wrapper">
                        <quill-editor 
                            ref="quillEditor" 
                            v-model="form.content" 
                            :options="editorOption"
                            @change="onEditorChange"
                        />
                    </div>
                </a-form-model-item>
            </a-form-model>
        </a-spin>
    </a-modal>
</template>

<script>
import {
		quillEditor
	} from 'vue-quill-editor';
    import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import '@/assets/quill/quill.zh.css';
	import quillOption from "@/assets/quill/quill.config";

export default {
    components: {
        quillEditor
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        loading: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            form: {
                id: 0,
                name: '',
                ident: '',
                content: ''
            },
            editorOption: quillOption,
        }
    },
    created() {
    },
    computed: {
        isUpdate: function() {
            return this.form.id > 0 ? true : false;
        }
    },
    methods: {
        initForm() {
            this.form = {
                id: 0,
                name: '',
                ident: '',
                content: ''
            }
            // 重置表单验证
            this.$nextTick(() => {
                if (this.$refs.adminForm) {
                    this.$refs.adminForm.clearValidate();
                }
            });
        },
        syncEditorContent() {
            // 同步编辑器内容
            if (this.$refs.quillEditor && this.$refs.quillEditor.quill) {
                const quill = this.$refs.quillEditor.quill;
                const currentContent = quill.root.innerHTML;
                const formContent = this.form.content || '';
                // 只有当内容不同时才更新，避免循环更新
                if (currentContent !== formContent && formContent !== '<p><br></p>') {
                    quill.clipboard.dangerouslyPasteHTML(formContent);
                }
            }
        },
        onEditorChange() {
            // vue-quill-editor 的 change 事件
            // 通过 v-model 已经自动同步了内容，这里只需要触发验证
            this.$nextTick(() => {
                if (this.$refs.adminForm) {
                    this.$refs.adminForm.validateField('content');
                }
            });
        },
        handleOk() {
            // 父组件会自己进行验证，这里直接触发事件
            this.$emit('ok');
        },
        handleCancel() {
            this.$emit('cancel');
        }
    },
    watch: {
        visible(newVal) {
            if (!newVal) {
                // 弹窗关闭时重置表单
                this.initForm();
            } else {
                // 弹窗打开时，确保编辑器内容同步（当父组件设置 form 数据后）
                this.$nextTick(() => {
                    this.syncEditorContent();
                });
            }
        },
        // 监听 form.content 变化，确保编辑器内容同步（用于修改时）
        'form.content'(newVal) {
            if (this.visible && newVal) {
                this.$nextTick(() => {
                    this.syncEditorContent();
                });
            }
        }
    }
}
</script>

<style scoped>
.quill-editor-wrapper {
    line-height: normal;
}

.quill-editor-wrapper >>> .ql-editor {
    min-height: 300px;
    max-height: 500px;
    overflow-y: auto;
}

.quill-editor-wrapper >>> .ql-container {
    font-size: 14px;
}

.quill-editor-wrapper >>> .ql-toolbar {
    border-top: 1px solid #d9d9d9;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
}

.quill-editor-wrapper >>> .ql-container {
    border-bottom: 1px solid #d9d9d9;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    border-top: none;
    border-radius: 0 0 4px 4px;
}
</style>